import React, { Fragment } from "react";
import { Hero, WelcomeSection } from "../../components/sections/become-partner";

export default function BecomePartner(props) {
	return (
		<Fragment>
			<Hero />

			<WelcomeSection />
		</Fragment>
	);
}
